import React, { useState } from 'react';

const ChartTabsLayout = ({ children, title, footer }) => {
  const [activeTab, setActiveTab] = useState("bubble"); // "activity" or "bubble"

  return (
    <div className="chart-tabs-layout" style={{
      backgroundColor: "var(--bg-secondary, #fafbfc)",
      borderRadius: "12px",
      padding: "1rem",
      marginBottom: "1rem"
    }}>
      {/* Tab Headers */}
      <div className="chart-tabs-header" style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        borderBottom: "1px solid var(--border-color, #ddd)",
        marginBottom: "1rem",
        backgroundColor: "var(--bg-secondary, white)",
        padding: "0.75rem",
        borderRadius: "8px",
        flexWrap: "wrap",
        gap: "0.5rem"
      }}>
        {title && (
          <div className="chart-tabs-title">
            {title}
          </div>
        )}
        <div className="chart-tabs-nav" style={{ display: "flex" }}>
          <button
            className="chart-tab-btn chart-tab-btn--bubble"
            onClick={() => setActiveTab("bubble")}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: activeTab === "bubble" ? "var(--pista-button-bg, #1976d2)" : "transparent",
              color: activeTab === "bubble" ? "white" : "var(--text-secondary, #666)",
              border: "none",
              borderBottom: activeTab === "bubble" ? "2px solid var(--pista-button-bg, #1976d2)" : "2px solid transparent",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "clamp(0.875rem, 2.5vw, 1rem)",
              transition: "all 0.2s ease",
              borderRadius: "8px 8px 0 0"
            }}
            onMouseOver={(e) => {
              if (activeTab !== "bubble") {
                e.target.style.backgroundColor = "var(--bg-tertiary, #f5f5f5)";
              }
            }}
            onMouseOut={(e) => {
              if (activeTab !== "bubble") {
                e.target.style.backgroundColor = "transparent";
              }
            }}
          >
            Tapestry
          </button>
          <button
            className="chart-tab-btn chart-tab-btn--activity"
            onClick={() => setActiveTab("activity")}
            style={{
              padding: "0.75rem 1.5rem",
              backgroundColor: activeTab === "activity" ? "var(--pista-button-bg, #1976d2)" : "transparent",
              color: activeTab === "activity" ? "white" : "var(--text-secondary, #666)",
              border: "none",
              borderBottom: activeTab === "activity" ? "2px solid var(--pista-button-bg, #1976d2)" : "2px solid transparent",
              cursor: "pointer",
              fontWeight: "600",
              fontSize: "clamp(0.875rem, 2.5vw, 1rem)",
              transition: "all 0.2s ease",
              borderRadius: "8px 8px 0 0"
            }}
            onMouseOver={(e) => {
              if (activeTab !== "activity") {
                e.target.style.backgroundColor = "var(--bg-tertiary, #f5f5f5)";
              }
            }}
            onMouseOut={(e) => {
              if (activeTab !== "activity") {
                e.target.style.backgroundColor = "transparent";
              }
            }}
          >
            Timeline
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="chart-tabs-content">
        {typeof children === 'function' ? children(activeTab) : children}
      </div>

      {/* Footer */}
      {footer && (
        <div className="chart-tabs-footer" style={{ marginTop: "1rem", paddingTop: "1rem", borderTop: "1px solid var(--border-color, #eee)" }}>
          {footer}
        </div>
      )}
    </div>
  );
};

export default ChartTabsLayout;
